'use client';

import {useCallback, useContext} from 'react';
import {ActiveScreenIdSubscriptionContext} from './ActiveScreenIdProvider';

/**
 * Returns a stable function to imperatively read the current active screen ID
 * without subscribing to changes. Use in event handlers to avoid re-renders.
 * Stable as long as the provider is mounted (getSnapshot has [] deps).
 */
export function useGetActiveScreenId(): () => string | null {
  const {getSnapshot} = useContext(ActiveScreenIdSubscriptionContext);
  return useCallback(() => getSnapshot()[0] ?? null, [getSnapshot]);
}
